import React from "react";
import TextLoop from "react-text-loop";
import logo from "../../assets/images/logo.png";

const LuckyDigit = ({ showResult, value, items, interval = 100, delay = 0, active }) => {
    return (
        <div className={`number-item ${active ? "active" : ""}`}>
            <div className="cover-image">
                <img src={logo} alt="logo" />
            </div>
            <div className="content">
                {!showResult && items && (
                    <TextLoop
                        className="draw-text"
                        interval={interval}
                        mask={true}
                        delay={delay}
                        springConfig={{ stiffness: 180, damping: 8 }}
                        children={items}
                    />
                )}
                {showResult && (
                    <div className="draw-text-result">
                        {value ?? 0}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LuckyDigit;
